var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"position":"fixed","width":"100%","top":"0","background":"rgba(255,255,255,1)","z-index":"1000"}},[_c('SiteHeader'),_c('SiteMenu')],1),_c('div',{staticStyle:{"height":"130px"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }